module.exports = __webpack_public_path__ + "img/player_jump_002.9657822f.png";